import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import StatCard from './StatCard';

function CaseStudyLevel1({ data, scenarioLabel }) {
  if (!data) return null;

  const { hours, summary } = data;

  const charts = [
    { key: 'vehicles', title: 'Edge Passages per Hour', plainKey: 'plain_vehicles', cpKey: 'cp_vehicles' },
    { key: 'vc', title: 'Mean V/C Ratio per Hour', plainKey: 'plain_vc', cpKey: 'cp_vc' },
    { key: 'congested', title: 'Congested Edges per Hour', plainKey: 'plain_congested', cpKey: 'cp_congested' },
  ];

  return (
    <div className="case-study-level">
      <h2>Level 1: Network Summary</h2>

      <div className="stat-cards-row">
        <StatCard title="Total VMT" value={summary.vmt.cp} change={summary.vmt.pct} unit="mi" />
        <StatCard title="Avg V/C Ratio" value={summary.avg_vc.cp} change={summary.avg_vc.pct} />
        <StatCard title="Avg Congested Edges" value={summary.avg_congested.cp} change={summary.avg_congested.pct} />
      </div>

      <div className="charts-grid">
        {charts.map(chart => (
          <div key={chart.key} className="chart-container">
            <h3>{chart.title}</h3>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={hours} margin={{ top: 5, right: 20, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#3a3a3a" />
                <XAxis dataKey="label" stroke="#aaa" fontSize={11} />
                <YAxis stroke="#aaa" fontSize={11} />
                <Tooltip
                  contentStyle={{ backgroundColor: '#2a2a2a', border: '1px solid #3a3a3a', color: '#fff' }}
                  labelStyle={{ color: '#aaa' }}
                />
                <Legend />
                <Line type="monotone" dataKey={chart.plainKey} name="Baseline" stroke="#ffffff" strokeWidth={2} dot={false} />
                <Line type="monotone" dataKey={chart.cpKey} name={scenarioLabel} stroke="#7CC644" strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        ))}
      </div>

      <div className="data-table-container">
        <h3>24-Hour Summary</h3>
        <div className="table-scroll">
          <table className="case-study-table">
            <thead>
              <tr>
                <th>Hour</th>
                <th>Passages (Base)</th>
                <th>Passages (Scen.)</th>
                <th>VMT (Base)</th>
                <th>VMT (Scen.)</th>
                <th>V/C (Base)</th>
                <th>V/C (Scen.)</th>
                <th>Congested (Base)</th>
                <th>Congested (Scen.)</th>
              </tr>
            </thead>
            <tbody>
              {hours.map(h => (
                <tr key={h.hour}>
                  <td>{h.label}</td>
                  <td>{h.plain_vehicles.toLocaleString()}</td>
                  <td>{h.cp_vehicles.toLocaleString()}</td>
                  <td>{h.plain_vmt.toLocaleString()}</td>
                  <td>{h.cp_vmt.toLocaleString()}</td>
                  <td>{h.plain_vc.toFixed(4)}</td>
                  <td>{h.cp_vc.toFixed(4)}</td>
                  <td>{h.plain_congested}</td>
                  <td>{h.cp_congested}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default CaseStudyLevel1;
